const getFilesInfoForDocSectionJournal = (fileList) => {
  return fileList.map(file => {
    return {
      fileName: file.name,
      fileId: file.uid,
    }
  })
}

export default getFilesInfoForDocSectionJournal;